import PosterUsersRatingList from './PosterUsersRatingList'

export default { list: PosterUsersRatingList }
